export const VESTING_PROGRAM_ID = process.env
  .REACT_APP_VESTING_PROGRAM_ID as string;

export const VESTING_CONFIG_ACCOUNT = process.env
  .REACT_APP_VESTING_CONFIG_ACCOUNT as string;

export const TOKEN_MINT = process.env.REACT_APP_TOKEN_MINT as string;

export const RPC_URL = process.env.REACT_APP_RPC_URL as string;
